import './icons.css';

const DownloadIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="https://www.w3.org/2000/svg"
  >
    <path
      d="M12 20L4 12L5.4 10.575L11 16.175V4H13V16.175L18.6 10.575L20 12L12 20Z"
      fill="inherit"
    />
  </svg>
);

export default DownloadIcon;
